import { injectable } from 'inversify';
import { computed, observable } from 'mobx';

import { ClientDataStore } from './client-data.store';
import { HomeApiService } from 'src/api';

@injectable()
export class HomeStore {
    @observable errorMessage: string | undefined;

    @computed get homeData() {
        return this.homeApi.getHomeDataObservable;
    }

    private lastFetch = 0;

    constructor(private clientData: ClientDataStore, private homeApi: HomeApiService) {
        this.refreshHomeData();
    }

    refreshHomeData() {
        if (this.clientData.isAnonymousPayments || !this.clientData.isInitialized) {
            return;
        }

        if (!this.clientData.isLoggedIn) {
            this.clientData.updateLoginData();
            if (this.clientData.isLoggedIn) {
                this.fetchHomeData();
            }
            return;
        }

        this.fetchHomeData();
    }

    private fetchHomeData() {
        const now = Date.now();
        if (this.lastFetch + 1000 > now) {
            // Don't refresh again within the same second
            return;
        }

        this.lastFetch = now;
        this.homeApi.getHomeData(true).catch((err) => {
            this.errorMessage = err;
        });
    }

    clearError() {
        this.errorMessage = undefined;
    }
}
